{
  "title": "Stinking Cloud",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a rotten egg or several skunk cabbage leaves)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You create a 20-foot-radius sphere of yellow, nauseating gas centered on a point within range. The cloud spreads around corners, and its area is heavily obscured. The cloud lingers in the air for the duration.",
    "Each creature that is completely within the cloud at the start of its turn must make a Constitution saving throw against poison. On a failed save, the creature spends its action that turn retching and reeling. Creatures that don’t need to breathe or are immune to poison automatically succeed on this saving throw.",
    "A moderate wind (at least 10 miles per hour) disperses the cloud after 4 rounds. A strong wind (at least 20 miles per hour) disperses it after 1 round."
  ],
  "spellLists": ["bard", "sorcerer", "wizard"]
}
